<template>
  <div>
    <div class="nav">
      <div class="pro-title">
        <img src="@/assets/image/logo.png" class="pro-logo" />
        <div class="pro-name">
          <el-select v-model="value">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="right-switch">
        <span @click="switchLanguage('zh_CN')" :class="['switch-zh', store.lang =='zh_CN'?'switch-active':'']">中文</span>
        <span @click="switchLanguage('en_US')" :class="['switch-en',store.lang =='en_US'?'switch-active':'']">En</span>
      </div>
    </div>
  </div>
</template>

<script>
import {store} from '@/store/index'
export default {
  data() {
    return {
      value: "选项1",
      options: [
        {
          value: "选项1",
          label: this.$t('top.common.itemName'),
        },
      ],
      store
    };
  },
  created() {
    this.changeTitle()
  },
  methods: {
    changeTitle() {
      document.title = this.$t('top.common.appTitle') || '研究简介'
    },
    dialogTableVisible() {
      this.$emit("dialogTableVisible")
    },
    switchLanguage(lang) {
      if(lang == this.store.lang) return
      this.store.setLang(lang)
			this.$router.go(0);
    }
  }
};
</script>
<style scoped>
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
}
.pro-title {
  display: flex;
  justify-content: start;
  align-items: center;
  flex: 1;
}
.pro-name{
  flex: 1;
  text-align: left;
}
.pro-logo {
  width: 90px;
  height: 33px;
  margin-right: 22px;
  
}
.el-select{
    width: 100%;
    pointer-events:none;
  }
.el-select /deep/ .el-input__inner {
  background: url(@/assets/image/down.png) no-repeat center center;
  background-size: 9px 5px;
  background-position: 511px;
  border: 1px solid #fff !important;
  font-weight: 600;
  font-size: 18px;
  height: 59px;
  color: #333333;
  margin: 0;
  padding: 0;
}
.el-select /deep/.el-input__suffix {
  right: 32px;
}
.el-select /deep/ .el-input .el-select__caret {
  display: none;
}
.right-switch{
  cursor: pointer;
  vertical-align: middle;
  /* display: flex; */
  /* align-content: center; */
}
.right-switch span{
  display: inline-block;
  width: 42px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid #E6E6E6;
  color:#333;
  }
.switch-zh{
  border-radius: 4px 0 0 4px;
}
.switch-en{
  border-radius: 0 4px 4px 0;
}
.right-switch .switch-active{
  background: #1890FF;
  border: 1px solid #1890FF;
  color:#fff;
}

</style>